import ProjectsTemplateMobile from "./projects-template-mobile";

export default ProjectsTemplateMobile;